export default __webpack_public_path__ + "static/media/Securing_the_Future_of_SRHR.909afff3.jpg";